export default __webpack_public_path__ + "static/media/rank-3.2044fc09.webp";